import React, { useState, useEffect } from 'react'
import { DappMenuSreen } from '../UI/DappMenuSreen';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';


import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import TextField from '@mui/material/TextField';
import { useForm } from '../../hooks/useForm';
//import Escrow from '../Escrow';
//import web3 from '../web3';

import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { Player, Controls } from '@lottiefiles/react-lottie-player';
import { useHistory } from "react-router-dom";

import { Wallet_model } from '../../models/Wallet_model';

import { app,db,storages } from "../../firebaseConfig/firebaseConfig";
import { getFirestore, collection, getDoc, setDoc, addDoc, doc, updateDoc } from 'firebase/firestore/lite';

import {ref, uploadString, uploadBytes, getDownloadURL,deleteObject , uploadBytesResumable } from 'firebase/storage'

import SaveIcon from '@mui/icons-material/Save';
import * as moment from 'moment';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';
export const DappContract = () => {


    const history = useHistory();
    const [selectedImage, setSelectedImage] = useState();
    let [document, setdocument] = useState('');
    const [metadata, setmetadata] = useState();


    const { web3Loading, getweb3 } = Wallet_model();

    const connectWallet = async () => {
        await getweb3().then((response) => {
            console.log((response));
            response.eth.getAccounts().then((result) => (
                console.log(result),
                localStorage.setItem("wallet", result[0])

            ));

        });
    }


    const handleDelete = () => {

    }


    const handleClick = () => {
        
    }



    //verUltimoContarto
    const [open, setOpen] = useState(false);
    const [newDialog, setnewDialog] = useState(false);
    const [contrato, setContrato] = useState('');
    const [comprobante, setComprobante] = useState('');
    const [contacts, setContacts] = useState([]);


    let create = false;

    const [formValues, handleInputChange] = useForm({
        depositante: '',
        depositario: '',
        comision: '',
        nombre: '',
        description: ''
    });

    const [optoken, setoptoken] = useState();



    const { depositante, depositario, comision, nombre, description } = formValues;



    const getContacts = async () => {
        const myuser = localStorage.getItem("uid");
        console.log(myuser);
        const docRef = doc(db, "users", myuser);
        const docSnap = await getDoc(docRef);


        if (!docSnap.exists) {
            console.log('No such document!');
        } else {
            console.log('Document data:', docSnap.data());
            //name = docSnap.data().name;
            let data = docSnap.data();
            console.log(data.name, "dede");
            let results = [];
            console.log(data.contacts,"todo");
            for(let contact of data.contacts){
                const documents = doc(db, "users", contact);
                const result = await getDoc(documents);
                const succesdata = {
                  name:  result.data().name,
                  email: result.data().email,
                  wallet: result.data().wallet,
                  imagen: result.data().img
                };
                results.push(JSON.stringify(succesdata));


            }

            console.log(results);

            console.log(contacts,"last")
            setContacts(results);

            console.log(contacts,"last")
           

        }
    }

    useEffect(() => {
        getContacts();
        return () => {
        }
    }, [false])


    const handleSubmit = async (e) => {


        const web3 = await getweb3();
        setOpen(true);
        console.log(document);
        console.log('form values', depositante, depositario, comision,optoken);
        const accounts = await web3.eth.getAccounts();
        let address ;
        let actualred = localStorage.getItem("red");
        if(actualred == "ropsten"){
         address = "0xa96D960dcEE05c77508b2F628706c5F7dF853DfB";
        }if(actualred == "mainnet"){
            address = "0x29a1914747eAa45877a422D7C734911C01BBb99E"; 
        }if(actualred == "polygon"){
            address = "0xf42bfadd0db306df1ce729237288fdf59c9faf4c";
        }if(actualred == "xdai"){
            address = "0xeC7fF01AdD91374c26c8225a2332B692F2680944";
            
        }if(actualred == "bnc"){
            address = "0xddbc97e87eb04c670c6aed2aaa49c505cce326ad";

        }
        const abi = [{ "anonymous": false, "inputs": [{ "indexed": false, "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }, { "indexed": false, "internalType": "uint256", "name": "_amount", "type": "uint256" }], "name": "Cancel", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "bytes", "name": "_agentSignature", "type": "bytes" }], "name": "CancelSignature", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }, { "indexed": false, "internalType": "address", "name": "_agent", "type": "address" }, { "indexed": false, "internalType": "address", "name": "_depositant", "type": "address" }, { "indexed": false, "internalType": "address", "name": "_retreader", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "_fee", "type": "uint256" }, { "indexed": false, "internalType": "contract IERC20", "name": "_token", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "_salt", "type": "uint256" }], "name": "CreateEscrow", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }, { "indexed": false, "internalType": "uint256", "name": "_toEscrow", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "_toEmyto", "type": "uint256" }], "name": "Deposit", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "contract IERC20", "name": "_token", "type": "address" }, { "indexed": false, "internalType": "address", "name": "_to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "_amount", "type": "uint256" }], "name": "EmytoWithdraw", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "_previousOwner", "type": "address" }, { "indexed": true, "internalType": "address", "name": "_newOwner", "type": "address" }], "name": "OwnershipTransferred", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "uint256", "name": "_fee", "type": "uint256" }], "name": "SetEmytoFee", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }, { "indexed": false, "internalType": "bytes", "name": "_agentSignature", "type": "bytes" }], "name": "SignedCreateEscrow", "type": "event" }, { "anonymous": false, "inputs": [{ "indexed": false, "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }, { "indexed": false, "internalType": "address", "name": "_sender", "type": "address" }, { "indexed": false, "internalType": "address", "name": "_to", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "_toAmount", "type": "uint256" }, { "indexed": false, "internalType": "uint256", "name": "_toAgent", "type": "uint256" }], "name": "Withdraw", "type": "event" }, { "constant": true, "inputs": [], "name": "BASE", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "_agent", "type": "address" }, { "internalType": "address", "name": "_depositant", "type": "address" }, { "internalType": "address", "name": "_retreader", "type": "address" }, { "internalType": "uint256", "name": "_fee", "type": "uint256" }, { "internalType": "contract IERC20", "name": "_token", "type": "address" }, { "internalType": "uint256", "name": "_salt", "type": "uint256" }], "name": "calculateId", "outputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }], "name": "cancel", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes", "name": "_agentSignature", "type": "bytes" }], "name": "cancelSignature", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "bytes", "name": "", "type": "bytes" }], "name": "canceledSignatures", "outputs": [{ "internalType": "bool", "name": "", "type": "bool" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "_depositant", "type": "address" }, { "internalType": "address", "name": "_retreader", "type": "address" }, { "internalType": "uint256", "name": "_fee", "type": "uint256" }, { "internalType": "contract IERC20", "name": "_token", "type": "address" }, { "internalType": "uint256", "name": "_salt", "type": "uint256" }], "name": "createEscrow", "outputs": [{ "internalType": "bytes32", "name": "escrowId", "type": "bytes32" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" }], "name": "deposit", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }], "name": "emytoBalances", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "emytoFee", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "contract IERC20", "name": "_token", "type": "address" }, { "internalType": "address", "name": "_to", "type": "address" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" }], "name": "emytoWithdraw", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "bytes32", "name": "", "type": "bytes32" }], "name": "escrows", "outputs": [{ "internalType": "address", "name": "agent", "type": "address" }, { "internalType": "address", "name": "depositant", "type": "address" }, { "internalType": "address", "name": "retreader", "type": "address" }, { "internalType": "uint256", "name": "fee", "type": "uint256" }, { "internalType": "contract IERC20", "name": "token", "type": "address" }, { "internalType": "uint256", "name": "balance", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "owner", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "uint256", "name": "_fee", "type": "uint256" }], "name": "setEmytoFee", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "_agent", "type": "address" }, { "internalType": "address", "name": "_depositant", "type": "address" }, { "internalType": "address", "name": "_retreader", "type": "address" }, { "internalType": "uint256", "name": "_fee", "type": "uint256" }, { "internalType": "contract IERC20", "name": "_token", "type": "address" }, { "internalType": "uint256", "name": "_salt", "type": "uint256" }, { "internalType": "bytes", "name": "_agentSignature", "type": "bytes" }], "name": "signedCreateEscrow", "outputs": [{ "internalType": "bytes32", "name": "escrowId", "type": "bytes32" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "_newOwner", "type": "address" }], "name": "transferOwnership", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" }], "name": "withdrawToDepositant", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "bytes32", "name": "_escrowId", "type": "bytes32" }, { "internalType": "uint256", "name": "_amount", "type": "uint256" }], "name": "withdrawToRetreader", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];
        const Escrow = await new web3.eth.Contract(abi, address);
        console.log(accounts);
        console.log(JSON.parse(contacts[depositante]).wallet,JSON.parse(contacts[depositario]).wallet, comision,optoken,accounts[0] );
        //const createScrow = await Escrow.methods.createEscrow("0x808205B361516ea642605017a0314895E6f95264","0xc744bfa219dca5069c5fee700c3978373523430a",50,"0xf32092b7c47e08e41220d8b5f727b96413e0a3e0",59).send({from: "0xffc643A3582F4388d6C913277f0b44D59354D8bD"})
        const createScrow = await Escrow.methods.createEscrow((JSON.parse(contacts[depositante])).wallet, (JSON.parse(contacts[depositario])).wallet, comision, optoken, 59).send({ from: accounts[0] });
        setOpen(false);
        setnewDialog(true);
        if (createScrow == undefined) {
            alert("Algo salio mal vuelva a intentarlo ");
            return;
        } else {
            setContrato(createScrow.events.CreateEscrow.returnValues._escrowId);
            setComprobante(createScrow.transactionHash);
            let myemail = localStorage.getItem("email")

            console.log('Contrato ID: ' + createScrow.events.CreateEscrow.returnValues._escrowId);
            console.log('Su comprobante:<br>' + createScrow.transactionHash);
            
                            const data = {
                                contratoId: createScrow.events.CreateEscrow.returnValues._escrowId,
                                comprobante: createScrow.transactionHash,
                                depositante: (JSON.parse(contacts[depositante])).wallet,
                                depositario: (JSON.parse(contacts[depositario])).wallet,
                                agente: accounts[0],
                                emagente: myemail,
                                emdepositario:(JSON.parse(contacts[depositario])).email,
                                emdepositante:(JSON.parse(contacts[depositante])).email,
                                imgagente: localStorage.getItem("image") != undefined ? localStorage.getItem("image") : '' ,
                                imgdepositante: (JSON.parse(contacts[depositante])).imagen != undefined ? (JSON.parse(contacts[depositante])).imagen : '' ,
                                imgdepositario: (JSON.parse(contacts[depositario])).imagen != undefined ? (JSON.parse(contacts[depositario])).imagen : '' ,
                                token: optoken,
                                red: localStorage.getItem("red"),
                                name: nombre,
                                description: description,
                                create: new Date()
                            }

                            console.log(data)
                            const docRef = await addDoc(collection(db, "contracts"), data);
                            console.log(docRef.id,"esto nos sirve bien");
                            const id = docRef.id;


                            const metadatas = { contentType: metadata}
                            const name = moment();
                            const data2 = await uploadString(ref(storages,"contracts/"+ name ),document, 'base64' ,metadatas);
                            const link2 = await getDownloadURL(ref(storages,"contracts/"+name));
                                   
                            console.log('Uploaded a blob or file!', link2);
                            
                        
                        const docRef2 = doc(db, "contracts", id);
                        const newData = {
                            file: link2
                        }
                        await updateDoc(docRef2, newData);

        }

    }


    const goToProfile = () => {
        history.push("/dapp/profile");
    }

    const [valid, setvalid] = useState(true)

    const fillToken = (e) => {
        if(e.target.value == 1 || e.target.value == 2){
            console.log(e.target.value);

            setoptoken('');
            setvalid(false)
        }else{
            setoptoken(e.target.value);
            setvalid(true)
        }

    }

    const changeoptoken = (e) => {
        setoptoken(e.target.value)
    }


    const imageChange = async (e) => {
        if (e.target.files && e.target.files.length > 0) {
            console.log(e.target.files[0],"x");
            if(e.target.files[0].size > 2000000){
                alert("Solo se aceptan archivos con un máximo de 2mb")
                return;
            }


            setSelectedImage(e.target.files[0].name);
        
            const reader = new FileReader();
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = async() => {
              console.log((reader));
              console.log(typeof(reader.result));

              let file = reader.result;
              console.log(file);
              file = file.split(",");
              console.log(file[1]);
                setdocument(file[1]);
                setmetadata(e.target.files[0].type);
            
        }

       
             
                     
        }
    };



    return (
        <div>
            <div className="dapp_container">
                <DappMenuSreen />
                {open &&
                    <Backdrop
                        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                        open={true}
                    >
                        <CircularProgress />

                        <h3>Creando Contrato...</h3>
                    </Backdrop>
                }

                <h4 style={{ marginTop: "130px", textAlign: "center", fontSize: "28px" }}>Nuevo contrato </h4>

                {!newDialog &&
                    <div className="dapp__center3">




                        <div className="dapp__profile">
                            <div className="dapp__one">

                                <Card className="dapp__c-100" >

                                    <CardContent>
                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                            <div className="dapp__one">



                                                <p>Información del contrato</p>

                                            </div>


                                        </Typography>
                                        <form onSubmit={handleSubmit}>
                                            <Box
                                                className="login__formbox"
                                                component="form"
                                                sx={{
                                                    width: 400,
                                                    maxWidth: '100%'
                                                }}
                                                noValidate
                                                autoComplete="off"
                                            >

<InputLabel className="login__input" >Selecciona un Depositante</InputLabel>
                                                <Select
                                                    id="Depositante"
                                                    className="login__input"
                                                    id="depositante"
                                                    name="depositante"
                                                    variant="filled"
                                                    value={depositante}
                                                    onChange={handleInputChange}
                                                >
                                                     {Array.from(contacts).map((_, index) => (
                                                    <MenuItem value={ index }> { (JSON.parse(contacts[index])).name   } / {((JSON.parse(contacts[index])).email)} </MenuItem>
                                                        ))}
                                                </Select>



<InputLabel className="login__input" >Selecciona un Depositario</InputLabel>
                                                <Select
                                                    id="Depositario"
                                                    className="login__input"
                                                    name="depositario"
                                                    variant="filled"
                                                    value={depositario}
                                                    onChange={handleInputChange}
                                                >
                                                     {Array.from(contacts).map((_, index) => (
                                                    <MenuItem value={ index }> { (JSON.parse(contacts[index])).name   } / {((JSON.parse(contacts[index])).email)} </MenuItem>
                                                        ))}
                                                </Select>



                                                    


                                                <InputLabel className="login__input" >Selecciona un token</InputLabel>
                                                <Select
                                                    className="login__input"
                                                    id="other"
                                                    variant="filled"
                                                    name="other"
                                                    label="Token"
                                                    onChange={(e) => { fillToken(e) }}
                                                >
                                                    <MenuItem value={1}>ERC-20</MenuItem>
                                                    <MenuItem value={2}>ERC-721</MenuItem>
                                                    <MenuItem value={"0xdac17f958d2ee523a2206206994597c13d831ec7"}>Theter USD (USDT)</MenuItem>
                                                    <MenuItem value={"0xa0b86991c6218b36c1d19d4a2e9eb0ce3606eb48"}>USD Coin</MenuItem>
                                                    <MenuItem value={"0x8e870d67f660d95d5be530380d0ec0bd388289e1"}>Paxos Standard</MenuItem>
                                                    <MenuItem value={"0x4fabb145d64652a948d72533023f6e7a623c7c53"}>Binance USD</MenuItem>
                                                    <MenuItem value={"0x0000000000085d4780B73119b644AE5ecd22b376"}>True USD</MenuItem>
                                                    <MenuItem value={"0x6b175474e89094c44da98b954eedeac495271d0f"}>Dai StableCoin</MenuItem>
                                                </Select>

                                                <TextField

                                                    id="optoken"

                                                    name="optoken"
                                                    type="text"
                                                    className="login__input"
                                                    value={optoken}
                                                    variant="filled"
                                                    disabled={valid}
                                                    onChange={ (e) => changeoptoken(e)}

                                                />

<InputLabel className="login__input" >Selecciona tu comisión</InputLabel>
                                            
                                                <TextField

                                                    id="comision"
                                                    label="Comisión"
                                                    name="comision"
                                                    type="number"
                                                    className="login__input"
                                                    value={comision}
                                                    variant="filled"
                                                    InputProps={{
                                                        inputProps: {
                                                            max: 15, min: 1
                                                        }
                                                    }}
                                                    onChange={handleInputChange}
                                                />




                                            </Box>

                                        </form>

                                    </CardContent>
                                    <CardActions>
                                    </CardActions>
                                </Card>
                            </div>

                        </div>

                        <div className="dapp__lastMoves">
                            <Card className="dapp__c-100" >
                                <CardContent>
                                    <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                        <div className="dapp__one">
                                            <p>Documentos extra del contrato</p>

                                        </div>


                                    </Typography>


                                    <form onSubmit={handleSubmit}>
                                        <Box
                                            className="login__formbox"
                                            component="form"
                                            sx={{
                                                width: 400,
                                                maxWidth: '100%'
                                            }}
                                            noValidate
                                            autoComplete="off"
                                        >
                                            <TextField
                                                id="Nombre del contrato"
                                                label="Nombre del contrato"
                                                className="login__input"
                                                name="nombre"
                                                variant="filled"
                                                value={nombre}
                                                onChange={handleInputChange}
                                            />
                                            <br></br>
                                            <TextField

                                                id="description"
                                                label="Descripción del contrato "
                                                name="description"
                                                className="login__input"
                                                value={description}
                                                multiline
                                                maxRows={4}
                                                variant="filled"

                                                onChange={handleInputChange}
                                            />

                                            <div className="dapp__fileoptions">

                                                {selectedImage && 
<Chip
className="dapp__chipdelete"
color="primary"
  label={selectedImage}
  onClick={handleClick}
  onDelete={handleDelete}
  variant="outlined"
/>
}

<input
                        accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,
                        text/plain, application/pdf, image/*"
                        type="file"
                        onChange={(event) => imageChange(event) }
                      
                    />

<Button variant="contained" className="dapp__filebutton"  startIcon={<SaveIcon />}>
  Upload File
</Button>

</div>



                                        </Box>

                                    </form>

                                </CardContent>
                                <CardActions>
                                </CardActions>
                            </Card>

                            <Button className="dapp__button" onClick={handleSubmit} variant="contained">Crear Contrato</Button>
                        </div>

                    </div>

                }
                {newDialog &&
                    <div className="dapp_finall">
                        <div>
                            <Player
                                className="dapp__lottie"
                                autoplay
                                loop
                                src="../assets/gifts/81943-block.json"
                            >
                            </Player>
                            <h1>Contrato creado con exito.</h1>
                            <p>ID Contrato:  {contrato} </p>
                            <p> Comprobante:  {comprobante} </p>
                            <Button className="dapp__button" onClick={goToProfile} variant="contained">Ver Contratos</Button>

                        </div>
                    </div>
                }
            </div>
        </div>
    )
}


